import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const inputCls = "w-full rounded-lg bg-white px-4 py-3 font-body text-sm outline-none border transition-colors";
const inputStyle = { borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" };
const FIELDS = [
  { name: "parent_name", label: "Parent / Guardian Name", required: true },
  { name: "child_name", label: "Child's Name", required: true },
  { name: "email", label: "Email Address", type: "email", required: true },
  { name: "phone", label: "Phone Number" },
];

export const VideoRequestForm = () => {
  const [form, setForm] = useState({});
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/video-requests", form);
      toast.success("Request received! Milly will reach out to confirm.");
      setForm({});
      e.target.reset();
    } catch {
      toast.error("Something went wrong. Please call 561-577-6346.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid sm:grid-cols-2 gap-5" data-testid="video-request-form">
      {FIELDS.map((f) => (
        <label key={f.name} className="block">
          <span className="overline block mb-2" style={{ color: "var(--navy)" }}>{f.label}{f.required && " *"}</span>
          <input type={f.type || "text"} required={f.required} className={inputCls} style={inputStyle} data-testid={`video-field-${f.name}`}
            onChange={(e) => setForm((s) => ({ ...s, [f.name]: e.target.value }))} />
        </label>
      ))}
      <label className="block sm:col-span-2">
        <span className="overline block mb-2" style={{ color: "var(--navy)" }}>Anything you'd love captured?</span>
        <textarea rows={3} className={inputCls} style={inputStyle} data-testid="video-field-notes"
          onChange={(e) => setForm((s) => ({ ...s, notes: e.target.value }))} />
      </label>
      <button type="submit" disabled={sending} className="btn-primary sm:col-span-2 justify-center" data-testid="video-request-submit">
        {sending ? <Loader2 size={18} className="animate-spin" /> : <>Request a Video <ArrowUpRight size={18} /></>}
      </button>
    </form>
  );
};
